import moment from 'moment';
import { useEffect, useRef } from 'react';

import { IGanttControl } from 'src/pages/gantt/gantt.interfaces';

import { IViewDateMap } from './gantt-view.interfaces';
import { COLUMN_HEIGHT, DATE_FORMAT_KEY } from './gantt-view.constants';

export const useAutoScrollToDate = (ganttControl: IGanttControl, dateMapByDate: IViewDateMap) => {
  const ref = useRef<any | null>(null);

  const keyDate = moment(ganttControl.scrollToDate).format(DATE_FORMAT_KEY);
  const dateRecord = ganttControl && dateMapByDate[keyDate || ''];

  useEffect(() => {
    if (ref.current && dateRecord?.index > -1) {
      const scrollTop = dateRecord.index * COLUMN_HEIGHT;

      ref.current.scrollTop = scrollTop;
    }
  }, [ganttControl.scrollToDate, dateRecord?.index]);

  return ref;
};
